import { DepotForm } from "@features/stock";
import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/depots/create")({
  staticData: {
    title: "Nouveau Dépôt",
    showInBreadcrumb: true,
    parent: "/_app/stock/depots",
  },
  loader: requirePermission("stock.depots.create"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouveau Dépôt</h1>
      </div>
      <div className="max-w-2xl">
        <DepotForm />
      </div>
    </div>
  );
}
